import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "d-flex justify-content-center my-4" }
const _hoisted_3 = { class: "d-flex justify-content-center" }
const _hoisted_4 = { class: "text-title-large" }
const _hoisted_5 = { class: "text-title-large font-weight-bold" }

import RegisterModal from '@/components/Common/RegisterModal.vue';
import { formatDateTime } from '@/services/functions';
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterModal',
  props: {
    modelValue: { type: Boolean },
    title: {},
    message: {},
    changeValues: {},
    execFunction: { type: Function }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function changeFormat(dateTime: string | null) {
  return dateTime ? formatDateTime(new Date(dateTime)) : '';
}

function exec() {
  props.execFunction();
  modelValue.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(RegisterModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    modalMaxWidth: "45%",
    width: "20%",
    title: props.title
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(props.message), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(changeFormat(props.changeValues[0])), 1),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "material-symbols-outlined mx-2" }, " arrow_right ", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(changeFormat(props.changeValues[1])), 1)
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_v_btn, {
        class: "ma-2 reset-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (modelValue.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        class: "ma-2 exec-btn",
        onClick: exec
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.dailyReports.alterLeavingOrReturning.execute')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})